const iosNotificationInterruptionLevelEnum = Object.freeze({
  PASSIVE: 0,
  ACTIVE: 1,
  SENSITIVE: 2,
  CRITICAL: 3
})

const iosNotificationInterruptionLevelLabels = Object.freeze({
  0: 'CampaignForm_Push_PushInterruption_Passive',
  1: 'CampaignForm_Push_PushInterruption_Active',
  2: 'CampaignForm_Push_PushInterruption_Sensitive',
  3: 'CampaignForm_Push_PushInterruption_Critical'
})

export {
  iosNotificationInterruptionLevelEnum,
  iosNotificationInterruptionLevelLabels
}



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/IosNotificationInterruptionLevelEnum.js